/***
 * File name: table.js
 *
 * Program Description:
 * This file contains all the meta configuration of the General Casues table in the
 * Cause of Incident master data.
 *
 * Includes the ff:
 * - Name, collection name, label and other static values for the table
 * - Route definitions
 * - Privilege name for role restrictions
 * - Table columns indicated as fields
 * - Action buttons on top of the table indicated as tableActions
 * - Action buttons per item inside the table indicated as entryActions
 * - Breadcrumbs definition
 *
 */
export default function (vm) {
  return {
    name: 'natureOfBreachTable',
    collectionName: 'natureOfBreach',
    dataView: 'default',
    label: 'Nature of Breach',
    tableHeader: 'Nature of Breach',
    route: {
      updateMultiple: 'natureOfBreach',
      list: 'natureOfBreach',
      deleteMultiple: 'natureOfBreach',
      upload: 'natureOfBreach'
    },
    hideSelect: false,
    privilege: 'canViewAllNatureOfBreach',
    fields: [
      {
        columnHeader: {
          sortable: true,
          text: 'Nature of Breach',
          value: 'value'
        }
      }
    ],
    tableActions: [
      {
        id: 'create',
        label: 'Add',
        icon: 'mdi-plus',
        color: 'white',
        vBind: {
          style: 'background-color: #162b54'
        },
        privilege: 'canPostNatureOfBreach',
        action: () => {
          vm.$emit('modalChange', 'create')
        }
      }
    ],
    entryActions: [
      {
        id: 'view',
        icon: 'mdi-eye',
        privilege: 'canViewNatureOfBreach',
        action: (item) => {
          vm.$emit('modalChange', 'view', item._id)
        }
      },
      {
        id: 'edit',
        icon: 'mdi-pencil',
        privilege: 'canViewNatureOfBreach',
        action: (item) => {
          vm.$emit('editRow', 'edit', item._id)
        }
      }
    ],
    breadcrumbs: {
      divider: '/',
      large: true,
      items: [
        {
          text: 'Nature of Breach'
        }
      ]
    }
  }
}
